var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_8850_2158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.7806 7.64437C15.3406 7.64437 16.6106 6.37437 16.6106 4.81437C16.6106 3.25437 15.3406 1.98438 13.7806 1.98438C12.2206 1.98438 10.9506 3.25437 10.9506 4.81437C10.9506 5.08437 11.0006 5.33437 11.0706 5.58437L7.16062 7.95437C6.65063 7.47437 5.97063 7.17438 5.22062 7.17438C3.66062 7.17438 2.39062 8.44438 2.39062 10.0044C2.39062 11.5644 3.66062 12.8344 5.22062 12.8344C5.91063 12.8344 6.54063 12.5744 7.03063 12.1644L10.1106 14.2744C10.0106 14.5644 9.94063 14.8644 9.94063 15.1944C9.94063 16.7544 11.2106 18.0244 12.7706 18.0244C14.3306 18.0244 15.6006 16.7544 15.6006 15.1944C15.6006 13.6344 14.3306 12.3644 12.7706 12.3644C12.0806 12.3644 11.4506 12.6244 10.9606 13.0344L7.88063 10.9244C7.98063 10.6344 8.05063 10.3344 8.05063 10.0044C8.05063 9.73438 8.00063 9.48437 7.93063 9.23437L11.8406 6.86438C12.3506 7.34438 13.0306 7.64437 13.7806 7.64437ZM13.7806 3.48438C14.5106 3.48438 15.1106 4.08437 15.1106 4.81437C15.1106 5.54437 14.5106 6.14437 13.7806 6.14437C13.0506 6.14437 12.4506 5.54437 12.4506 4.81437C12.4506 4.08437 13.0506 3.48438 13.7806 3.48438ZM5.22062 11.3244C4.49062 11.3244 3.89062 10.7244 3.89062 9.99438C3.89062 9.26438 4.49062 8.66437 5.22062 8.66437C5.95063 8.66437 6.55063 9.26438 6.55063 9.99438C6.55063 10.7244 5.95063 11.3244 5.22062 11.3244ZM12.7806 13.8544C13.5106 13.8544 14.1106 14.4544 14.1106 15.1844C14.1106 15.9144 13.5106 16.5144 12.7806 16.5144C12.0506 16.5144 11.4506 15.9144 11.4506 15.1844C11.4506 14.4544 12.0506 13.8544 12.7806 13.8544Z",
    fill: "#9F9CA3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8850_2158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandShareIcon);
export default __webpack_public_path__ + "static/media/brand-share-icon.e81b990f9015e9fb9739e513ba641373.svg";
export { ForwardRef as ReactComponent };